import React, { Component } from 'react';


//IMPORT REDUX
import { connect } from 'react-redux';
import { addModalExport } from '../../../redux/actions/ConfigFileAction'

import Exit from '../../../assets/svg/Exit.svg';

//IMPORT SEMANTIC COMPONENTS
import 'semantic-ui-css/semantic.min.css';
import {
    Grid,
    Segment,
    Button,
    Icon,
    Modal,
    Header,
    Image
} from 'semantic-ui-react';

// PDF
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';


// CSS
import './modalExport.css'


import Excel from '../../../assets/img/excel.png';
import Adobe from '../../../assets/img/adobe.png';

import { translate } from "react-translate";

import { Currencies } from '../../../constants/Currencies';

// API
import API from '../../../services/api'

// Excel
import ReactExport from "react-data-export";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const mapStateToProps = state => ({
    app: state.app,
    configfile: state.configfile
})

const mapActionToProps = {
    addModalExport: addModalExport
}

class ListModalExport extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currency: "EUR",
          }

        // Bind Redux
        this.closeModalExport = this.closeModalExport.bind(this)
        this.handleSubmitExport = this.handleSubmitExport.bind(this)
        this.buildExcelDataSet = this.buildExcelDataSet.bind(this);
        this.loadImage = this.loadImage.bind(this);
        this.asyncImageProcessing = this.asyncImageProcessing.bind(this);
    }

    componentWillMount() {
        var self = this;
        API.getUser(this.props.app.token).then((res) => {
            let tmpResponseCurrencies = Currencies.filter(currency => currency.value == res.data.currency);
            self.setState({
                currency: tmpResponseCurrencies.length > 0 ? tmpResponseCurrencies[0].text : '€',
            })
        });
        setTimeout(() => {
            this.buildExcelDataSet().then(result => {
                var sheet = [];
                sheet.push(result);
                // Building contact set
                let contactSet = {
                    xSteps: 1,
                    ySteps: 5,
                    columns : [],
                    data : []
                };
                contactSet.columns.push('MYTRAVO');
                contactSet.columns.push('');
                var appLinkRow = ['Lien vers l\'application', 'https://play.google.com/store/apps/details?id=com.guidiyam.mytravo'];
                var contactRow = ['Contact', 'contact@mytravo.net'];
                var siteRow = ['Site:', 'www.mytravo.net'];
                contactSet.data.push(appLinkRow);
                contactSet.data.push(contactRow);
                contactSet.data.push(siteRow);


                sheet.push(contactSet);
                this.setState({excelSheet : sheet});
                });
        }, 2000); // We need to change this Timeout to listen for the redux action addArticle
        
      }

      loadImage(article) {
        return new Promise((resolve) => {
            var xhr = new XMLHttpRequest()
            xhr.open("GET", API.resourceURL + "/" + article.link_picture);
            xhr.responseType = "blob";
            xhr.send();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.readAsDataURL(xhr.response); 
                reader.addEventListener("loadend", function() {
                    resolve(reader.result)
                });
            };
        }); 
      }

    // MODAL functions
    closeModalExport() {
        this.props.addModalExport(false)
    }

    handleSubmitExport() {
        var self = this;
        var pdf = new jsPDF('p', 'pt', 'letter');

        var margins = {
            top: 60,
            left: 60,
            width: 630,
            height: 800
        };

        let html = ["<body>"];
        html.push('<h1 style="display: block; width:80%; margin: auto; text-align: center;">Liste de courses</h1>');
        html.push('<h2 style="display: block; width:80%; margin: auto; text-align: center;">' + this.props.list.list.name + '</h2>');
        html.push("<hr/>")
        html.push('<table style="border: 1px solid black; width: 90%; display: block; margin: auto; ">');
        html.push('<thead>');
        html.push('<th>Image</th>');
        html.push('<th>Article</th>');
        html.push('<th>State</th>');
        html.push('<th>Price</th>');
        html.push('<th>Quantity</th>');
        html.push('<th>Total price</th>');
        html.push('</tr></thead>');
        html.push('<tbody>')
        let articles = this.props.list.article;

        let buildTableCell = (content) => {
            html.push('<td style="border:1px solid black; text-align:center; ">')
            html.push('<p>' + content + '</p>')
            html.push('</td>')
        }

        var imgPromises = [];

        articles.map((article, index) => {
           imgPromises.push(this.loadImage(article));
        });
        Promise.all(imgPromises).then(function(images){
            articles.map((article, index) => {
                let articleName = article.name || article.name_manually;
                let articleUnitPrice = article.price;
                let quantity = article.quantity;
                let totalPrice = Number(quantity) * Number(articleUnitPrice);
                let articleEnabled = article.state;
                html.push('<tr>')
                buildTableCell('<img width="50" height="50" src="'+ images[index] +'" />');
                buildTableCell(articleName);
                if(articleEnabled){
                    buildTableCell("&#x2714") // Checked mark
                } else {
                    buildTableCell("&#x2716") // Cross mark
                }
                buildTableCell(articleUnitPrice + self.state.currency);
                buildTableCell(quantity);
                buildTableCell(totalPrice + self.state.currency);
                html.push('</tr>')
            });
            html.push("</tbody></table>");            
            html.push("<h4>MYTRAVO :</h4>")
            html.push("<p>Lien vers l'application : https://play.google.com/store/apps/details?id=com.guidiyam.mytravo</p>")
            html.push("<p>Contact : contact@mytravo.net</p>")
            html.push("<p>Site : www.mytravo.net</p></center>")
            html.push("</body>")

            let html_string = html.join("");
            var iframe=document.createElement('iframe');
            iframe.width = margins.width;
            iframe.height = margins.height;
            document.body.appendChild(iframe);
            setTimeout(function(){
                var iframedoc=iframe.contentDocument||iframe.contentWindow.document;
                iframedoc.body.innerHTML=html_string;
               
                    html2canvas(iframedoc.body).then(canvas => {
                        document.body.removeChild(iframe);
                        var img = canvas.toDataURL("image/png");
                        pdf.addImage(img, 'JPEG', margins.left, margins.top);
                        pdf.save(self.props.list.list.name + '.pdf');
                        self.closeModalExport();
                    });
            }, 10);
        })
    }

    asyncImageProcessing = (imgPromises) => {
        var self = this;
        return new Promise(resolve => {
            var data = [];
            Promise.all(imgPromises).then(function(images){
                var articles = Array.isArray(self.props.list.article) ? self.props.list.article : [];
                articles.map((article, index) => {
                    var row = [];
                    // Image
                    row.push(images[index])
                    // Article
                    var name = article.name || article.name_manually;
                    row.push(name);
                    // State
                    if(article.state) {
                        row.push("On");
                    } else {
                        row.push("Off");
                    }
                    // Price
                    row.push(article.price);
                    // Quantity
                    row.push(article.quantity);
                    // Total price
                    row.push(Number(article.price) * Number(article.quantity));
                    data.push(row);
               })
               resolve(data);
            });
        }); 
        
    }

    buildExcelDataSet() {
       var self = this;
       let articlesSet = {
           xSteps: 1,
           ySteps: 1,
           columns : [],
           data : []
       };
       // Building columns headers
       articlesSet.columns.push('Image');
       articlesSet.columns.push('Article');
       articlesSet.columns.push('State');
       articlesSet.columns.push('Price');
       articlesSet.columns.push('Quantity');
       articlesSet.columns.push('Total price');

       var imgPromises = [];
       var articles = Array.isArray(self.props.list.article) ? self.props.list.article : [];
       articles.map((article, index) => {
           imgPromises.push(self.loadImage(article));
        });

        return new Promise( res => {
            this.asyncImageProcessing(imgPromises).then(result => {
                articlesSet.data = result;
                res(articlesSet);
            })
        })
        
    }

    render() {
        const { t } = this.props;
        return (

            <div>
                <Modal
                    open={this.props.configfile.modal_export}
                    onClose={this.closeModalExport}
                    size='tiny'
                    id="modalExport"
                >
                    <Modal.Header id="modalHeader">
                        <Grid>
                            <Grid.Row>
                                <Grid.Column textAlign='center'>
                                    <Image
                                        id="modalExit"
                                        onClick={this.closeModalExport}
                                        src={Exit}
                                        floated='right' />
                                    <Header
                                        as='h2'
                                        id="modalTitle"
                                        textAlign='center'>
                                        Exporter la liste
                                  </Header>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Modal.Header>
                    {
                        this.props.list && this.props.list.list ? (
                            <div>
                                <Modal.Content >
                                    <Grid padded >
                                        <Grid.Row columns={2} centered style={{ margin: '20px 0' }}>
                                            <Grid.Column textAlign='center' width={6}>
                                                <ExcelFile element={
                                                    <Segment id='exportMethod'>
                                                        <Image centered src={Excel} />
                                                        <span>{t("excel")}</span>
                                                    </Segment>   
                                                }
                                                filename = {this.props.list.list.name}
                                                >
                                                    <ExcelSheet data={this.state.excelSheet}  dataSet = {this.state.excelSheet} name="My Travo List">
                                                    </ExcelSheet>
                                                </ExcelFile>        
                                            </Grid.Column>
                                            <Grid.Column textAlign='center' width={6}>
                                              <Segment id='exportMethod' onClick={this.handleSubmitExport}>
                                                    <Image centered src={Adobe} />
                                                    <span>{t("pdf")}</span>
                                                </Segment>
                                            </Grid.Column>

                                        </Grid.Row>
                                    </Grid>
                                </Modal.Content>
                            </div>
                        ) : (
                                <Modal.Content>
                                    <Grid
                                        textAlign='center'
                                        style={{ height: '100%' }}
                                        verticalAlign='middle'>
                                        <Grid.Column>
                                            <a href='/'><Image floated='right' /></a>
                                            <Header as='h3' id="modalExportError" textAlign='center'>
                                                {t("error")}
                                            </Header>
                                            <Header as='h5' id="modalExportErrorDescription">{t("prevention")}</Header>
                                        </Grid.Column>
                                    </Grid>

                                </Modal.Content>
                            )
                    }
                </Modal>
            </div>
        )
    }
}

const ConnectedListExport = connect(mapStateToProps, mapActionToProps)(ListModalExport);
export default translate("ModalExport")(ConnectedListExport);



// WEBPACK FOOTER //
// ./src/components/Protected/Listes/ModalExport.jsx